// created to avoid circular dependencies

export const ORGANIZATION_LABEL = 'organization';
export const NO_DEPARTMENT = 'no_department';

export const NAME = 'name';
export const ORDER_KEY = 'order_key';
export const DELAYED_SHIPPING_BASE_URL = 'delayed_shipping_base_url';
export const SALESFORCE_CAMPAIGN_ID = 'salesforce_campaign_id';
export const SALESFORCE_CLIENT_ID = 'salesforce_client_id';
export const SALESFORCE_CLIENT_SECRET = 'salesforce_client_secret';
export const SALESFORCE_CLIENT_SECRET_HAS_VALUE = 'salesforce_client_secret_has_value';
export const RYBBON_CLIENT_ID = 'rybbon_client_id';
export const RYBBON_CLIENT_SECRET = 'rybbon_client_secret';
export const RYBBON_CLIENT_SECRET_HAS_VALUE = 'rybbon_client_secret_has_value';
export const SHIPPING_ADDRESS = 'shipping_address';
export const DELAYED_SHIPPING_PAGE = 'delayed_shipping_page';
export const BUTTON_COLOR = 'button_color';
export const HEADER_COLOR = 'header_color';
export const EMAIL = 'email';
export const STREET1 = 'street1';
export const STREET2 = 'street2';
export const CITY = 'city';
export const STATE = 'state';
export const POSTAL_CODE = 'postalCode';
export const RESIDENTIAL = 'residential';
export const COUNTRY = 'country';
export const PHONE = 'phone';
export const LOGO_URL = 'logo_url';
export const SQUARE_LOGO_URL = 'square_logo_url';
export const VECTOR_IMAGE_URL = 'vector_image_url';
export const SQUARE_COBRANDING_LOGO_URL = 'square_cobranding_logo_url';
export const PORTAL_USE_COBRANDING_LOGO = 'portal_use_cobranding_logo';
export const SOB_ENABLED = 'send_on_behalf_of_enabled';
export const USER_BUDGET_ENABLED = 'user_budget_enabled';
export const DEPARTMENT_BUDGET_ENABLED = 'department_budget_enabled';
export const DIGITAL_BALANCE_LIMIT_ENABLED = 'digital_balance_limit_enabled';
export const AUTOMATIONS_ENABLED = 'automated_campaigns_enabled';
export const DIGITAL_BALANCE_LIMIT_VALUE = 'digital_balance_limit_value';
export const ORG_OPTIONS = 'org_options';
export const CRM_CURRENTLY_SUPPORTS = 'crm_currently_supports';
export const CRM_SKIP_ALLOWED = 'crm_skip_allowed';
export const EMAIL_CURRENTLY_SUPPORTS = 'email_currently_supports';
export const SIGN_IN_METHOD_SUPPORTS = 'sign_in_method_supports';
export const ORG_CUSTOMIZATION_OPTIONS = 'org_customization_options';
export const EMAIL_USE_ORG_LOGO = 'email_use_org_logo';
export const EMAIL_ACCENT_COLOR = 'email_accent_color';
export const EMAIL_MAIN_COLOR = 'email_main_color';
export const EMAIL_LOGO_TYPE = 'email_logo_type';
export const PORTAL_SIDEBAR_COLOR = 'portal_sidebar_color';
export const PORTAL_SIDEBAR_TEXT_COLOR = 'portal_sidebar_text_color';
export const PORTAL_ACCENT_COLOR = 'portal_accent_color';
export const PORTAL_SIDEBAR_ACCENT_COLOR = 'portal_sidebar_accent_color';
export const PORTAL_USE_ORG_LOGO = 'portal_use_org_logo';
export const RECT_COBRANDING_LOGO_URL = 'rect_cobranding_logo_url';
export const SHIPPING_PAGE_TITLE = 'shipping_page_title';
export const SHIPPING_PAGE_BODY = 'shipping_page_body';
export const PICK_YOUR_GIFT_TITLE = 'pick_your_gift_title';
export const PICK_YOUR_GIFT_BODY = 'pick_your_gift_body';
export const MSKU_PAGE_TITLE = 'msku_page_title';
export const MSKU_PAGE_BODY = 'msku_page_body';
export const CUSTOMIZE_ITEMS_PAGE_TITLE = 'customize_items_page_title';
export const CUSTOMIZE_ITEMS_PAGE_BODY = 'customize_items_page_body';
export const ORG_ID = 'org_id';
export const AVAILABLE_BUDGET = 'available_budget';
export const USED_BUDGET = 'used_budget';
export const LOW_INVENTORY_NOTIFICATION_EMAILS = 'low_inventory_notification_emails';
export const AI_GIFT_SUGGESTION_ENABLED = 'ai_gift_suggestion_enabled';
export const HUBSPOT_APP_ENABLED = 'hubspot_app_enabled';
export const REQUIRE_BUSINESS_REASON_FOR_DIRECT_SENDS = 'require_business_reason_for_direct_sends';
export const PRODUCT_MARKETPLACE_ENABLED = 'product_marketplace_enabled';
export const RECURRING_ANONYMIZATION = 'recurring_anonymization';
export const RECURRING_ANONYMIZATION_ENABLED = 'enabled';
export const RECURRING_ANONYMIZATION_CADENCE_DAYS = 'cadence_days';
export const RECURRING_ANONYMIZATION_LAST_RUN_STATUS = 'last_run_status';
export const RECURRING_ANONYMIZATION_ENABLED_FIELD = `${ORG_OPTIONS}.${RECURRING_ANONYMIZATION}.${RECURRING_ANONYMIZATION_ENABLED}`;
export const RECURRING_ANONYMIZATION_CADENCE_DAYS_FIELD = `${ORG_OPTIONS}.${RECURRING_ANONYMIZATION}.${RECURRING_ANONYMIZATION_CADENCE_DAYS}`;
export const LAST_RUN_TIMESTAMP = 'timestamp';
export const LAST_RUN_NUMBER_SENDS = 'number_sends';
export const LAST_RUN_STATUS = 'status';
export const LAST_RUN_ERROR_MESSAGE = 'error_message';
export const EMAIL_CUSTOM_SENDER = 'email_custom_sender';
export const AUTOMATION_CONNECTIONS = 'automation_connections';
export const STORAGE_EVENT = 'storage';
export const ORG_DEPARTMENTS = 'org_departments';

export const NO_DEPARTMENT_ITEM = {
  uid: NO_DEPARTMENT,
  name: 'No department',
};

export const RYBBON_HELP_TOOLTIP_TEXT = 'This field is not required. Put in a Client ID and a Client Secret primarily.';

export const COBRANDING_LOGO_HELP_TOOLTIP_TEXT = 'This logo will be used in a portal for co-branded organizations.';
export const COBRANDING_LOGO_DISABLED_TOOLTIP_TEXT =
  'To enable this feature at least rectangular co-branding logo should be uploaded.';

export const DISTRIBUTORS_NOTIFICATION_EMAILS_LIST_HELP_TEXT = 'The recipients will receive the email twice a month.';

export const RECURRING_ANONYMIZATION_MIN_CADENCE_DAYS = 30;
export const RECURRING_ANONYMIZATION_DEFAULT_CADENCE_DAYS = 30;
export const RECURRING_ANONYMIZATION_MAX_CADENCE_DAYS = 9999;
export const RECURRING_ANONYMIZATION_CADENCE_PRESETS = [30, 60, 90, 180, 365];
export const RECURRING_ANONYMIZATION_CADENCE_REQUIRED_MESSAGE = 'Enter a number of days';
export const RECURRING_ANONYMIZATION_CADENCE_MIN_MESSAGE = `Minimum is ${RECURRING_ANONYMIZATION_MIN_CADENCE_DAYS} days`;
export const RECURRING_ANONYMIZATION_CADENCE_INTEGER_MESSAGE = 'Whole days only';
export const RECURRING_ANONYMIZATION_CADENCE_LABEL = 'Redact sends that finished more than';
export const RECURRING_ANONYMIZATION_CADENCE_HELP_TEXT =
  'Counted from the day a send expired or was canceled, completed, delivered or failed';
export const RECURRING_ANONYMIZATION_HELP_TEXT = [
  'A daily job checks sends that have expired or were canceled, completed, delivered or failed. Once a send is older than the set number of days (counted from that status date), its recipient data is redacted.',
  'Names, email, phone and address are replaced with randomly generated values. Sender data is never changed. Matching records in IEOS are updated too.',
  'Redaction can’t be undone.',
];

export const REMOVE_PII_MAX_DATE_OFFSET_DAYS = RECURRING_ANONYMIZATION_MIN_CADENCE_DAYS;
export const REMOVE_PII_DESCRIPTION =
  'Select the date range of finished sends whose recipient info should be redacted.';
export const REMOVE_PII_NOTES = [
  'Includes sends that expired or were canceled, completed, delivered or failed inside the range — measured from that status date, not the order date.',
  'Names, email, phone and address are replaced with randomly generated values. Sender data is not changed.',
  `Dates must be at least ${RECURRING_ANONYMIZATION_MIN_CADENCE_DAYS} days in the past. This can’t be undone.`,
];
export const REMOVE_PII_ERROR_MESSAGE = 'Recipient PII could not be removed. Try again.';
export const getRemovePIIStartedMessage = (organizationName: string | undefined, from: string, to: string) =>
  `Recipient PII redaction started${
    organizationName ? ` for ${organizationName}` : ''
  } for sends finished ${from} – ${to}. You can check the result later under Last check in the organization settings.`;

export const RUN_ANONYMIZATION_CHECK_MAX_DATE_OFFSET_DAYS = RECURRING_ANONYMIZATION_MIN_CADENCE_DAYS;
export const RUN_ANONYMIZATION_CHECK_DIALOG_TITLE = 'Run anonymization now';
export const RUN_ANONYMIZATION_CHECK_DIALOG_CONFIRM_LABEL = 'Run now';
export const RUN_ANONYMIZATION_CHECK_DIALOG_DESCRIPTION =
  'Select the date range of finished sends whose recipient data should be anonymized. The range is based on the date each send reached its final status, not the date it was created.';
export const RUN_ANONYMIZATION_CHECK_POLL_INTERVAL_MS = 15000;
export const RUN_ANONYMIZATION_CHECK_POLL_TIMEOUT_MS = 10 * 60 * 1000;
export const RUN_ANONYMIZATION_CHECK_MAX_CONSECUTIVE_FAILURES = 4;
export const RUN_ANONYMIZATION_CHECK_NOTIFICATION_ID = 'anonymization-run-check';
export const RUN_ANONYMIZATION_CHECK_STORAGE_KEY = 'iex.runAnonymizationCheck';
export const RUN_ANONYMIZATION_CHECK_START_ERROR_MESSAGE = 'The anonymization check could not be started. Try again.';
export const RUN_ANONYMIZATION_CHECK_FAILED_MESSAGE = 'The anonymization check did not complete. Try again.';
export const RUN_ANONYMIZATION_CHECK_TIMED_OUT_MESSAGE =
  'The anonymization check is taking longer than expected and may still be running. Reload the page later to see the result under Last check.';
export const RUN_ANONYMIZATION_CHECK_STATUS_UNAVAILABLE_MESSAGE =
  'Could not check the anonymization status. Reload the page later to see the result under Last check.';
export const ENABLE_ANONYMIZATION_WARNING_TITLE = 'Turn on scheduled anonymization?';
export const ENABLE_ANONYMIZATION_WARNING_CONFIRM_LABEL = 'Turn on and save';
export const ENABLE_ANONYMIZATION_WARNING_PREFIX = 'Recipient data in sends that finished before ';
export const getEnableAnonymizationWarningSuffix = (cadenceDays: number) =>
  ` (over ${cadenceDays} days ago) will be redacted on the next daily check. This can’t be undone.`;
export const getRedactedSendsLabel = (numberSends: number) =>
  `${numberSends.toLocaleString('en-US')} ${numberSends === 1 ? 'send' : 'sends'} redacted`;
export const getRunAnonymizationCheckCompletedMessage = (numberSends: number) =>
  `Anonymization check completed. ${getRedactedSendsLabel(numberSends)}.`;
